// Unicode-safe base64 helpers.
//
// window.btoa throws "The string to be encoded contains characters outside of
// the Latin1 range" when the input has non-Latin1 characters (em-dash, curly
// quotes, emoji, accented letters). Milestone/job names can contain these, which
// crashed the fund-milestone auto-reply after a *successful* payment (UD-318).
//
// safeBtoa UTF-8 encodes before base64; safeAtob reverses it. They must be used
// as a pair so the round trip (encode → store as message body → decode) matches.

export const safeBtoa = (str) => {
	try {
		return window.btoa(unescape(encodeURIComponent(String(str))));
	} catch (e) {
		// Last-resort fallback: replace anything outside the Latin1 range (char
		// code > 255) so window.btoa never throws.
		const latin1 = Array.from(String(str), (ch) => (ch.charCodeAt(0) > 0xff ? '?' : ch)).join('');
		return window.btoa(latin1);
	}
};

export const safeAtob = (b64) => {
	try {
		return decodeURIComponent(escape(window.atob(b64)));
	} catch (e) {
		// Body may have been encoded the old (non-UTF-8) way — fall back to raw atob.
		try {
			return window.atob(b64);
		} catch (_) {
			return '';
		}
	}
};
